import styled, { keyframes } from 'styled-components';

const pulseAnimation = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
`;

export const ModalContent = styled.div`
  padding: 20px 20px 16px;
  text-align: center;
`;

export const IconContainer = styled.div`
  margin-bottom: 16px;
`;

export const WarningIcon = styled.div`
  width: 48px;
  height: 48px;
  margin: 0 auto;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  animation: ${pulseAnimation} 2s ease-in-out infinite;
  box-shadow: 0 6px 16px rgba(255, 77, 79, 0.25);
`;

export const ContentSection = styled.div`
  margin-bottom: 20px;
`;

export const Title = styled.h2`
  font-size: 17px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 10px 0;
  line-height: 1.3;
`;

export const ItemName = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: #1677ff;
  margin-bottom: 10px;
  padding: 6px 12px;
  background: rgba(22, 119, 255, 0.08);
  border-radius: 6px;
  display: inline-block;
`;

export const Description = styled.p`
  font-size: 13px;
  color: #666;
  margin: 0 0 10px 0;
  line-height: 1.4;
`;

export const WarningText = styled.p`
  font-size: 12px;
  color: #ff4d4f;
  margin: 0;
  line-height: 1.4;
  font-weight: 500;
`;

export const ButtonSection = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export const CancelButton = styled.button`
  padding: 8px 16px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 6px;
  background: white;
  color: #666;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
  
  &:hover:not(:disabled) {
    border-color: #1677ff;
    color: #1677ff;
  }
  
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const DeleteButton = styled.button<{ isLoading?: boolean }>`
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  background: linear-gradient(135deg, #ff4d4f 0%, #ff7875 100%);
  color: white;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 110px;
  justify-content: center;
  
  &:hover:not(:disabled) {
    background: linear-gradient(135deg, #ff7875 0%, #ff4d4f 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255, 77, 79, 0.3);
  }
  
  &:active:not(:disabled) {
    transform: translateY(0);
  }
  
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
  
  .anticon {
    font-size: 14px;
    ${props => props.isLoading && `
      animation: ${spinAnimation} 1s linear infinite;
    `}
  }
`;

// Mobile responsive styles
export const MobileModalContent = styled(ModalContent)`
  @media (max-width: 768px) {
    padding: 24px 16px 16px;
    
    ${Title} {
      font-size: 20px;
    }
    
    ${ItemName} {
      font-size: 16px;
    }
    
    ${Description} {
      font-size: 14px;
    }
    
    ${WarningText} {
      font-size: 13px;
    }
    
    ${ButtonSection} {
      flex-direction: column;
      gap: 8px;
    }
    
    ${CancelButton}, ${DeleteButton} {
      width: 100%;
      min-width: auto;
    }
  }
`;
